import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager'
import 'intersection-observer';
import { useInView } from 'react-intersection-observer';

const LazyLoadObserver = (props) => {
    const isComponent = props.isComponent ? props.isComponent : false; 
    
    const [ref, inView] = useInView({
        threshold: isComponent ? 0.01 : 0.2,
        rootMargin: "32px 16px",
        triggerOnce: true
    });

    useEffect(() => {
        if (inView && props.gtmData) {
            TagManagerService.gtmHome(props.gtmData)
        }
        if (inView && props.callback) {
            props.callback();
        }
    }, [inView])

    return <div ref={ref} className={(props.className || '') + (!inView && isComponent ? ' not-view ' : '')} >
        {inView && props.children}
    </div>
}

LazyLoadObserver.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    className: PropTypes.string,
    isComponent: PropTypes.bool,
    gtmData: PropTypes.object
};

export default LazyLoadObserver;
